// @src/pre-deployment/src/utils/componentScanner.js v2.0
// - Browser-compatible component scanner that works with predefined component registry
// - No Node.js dependencies - works in browser environment
// - Integrates with UploadLearningModulesOrder for component management
// - Uses predefined component registry instead of file system scanning

/**
 * Predefined registry of available learning module components
 * This is managed through the admin interface and updated during deployment
 */
const AVAILABLE_COMPONENTS_REGISTRY = {
  'chapterTitle': {
    displayName: 'Chapter Title',
    routePath: 'chapterTitle',
    component: 'ChapterTitleScreen',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'dialogue': {
    displayName: 'Dialogue Practice',
    routePath: 'dialogue',
    component: 'DialogueFeature',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'dialogueVocab': {
    displayName: 'Vocab Dialogue',
    routePath: 'dialogueVocab',
    component: 'DialogueUniversal',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'dialogueGrammar': {
    displayName: 'Grammar Dialogue',
    routePath: 'dialogueGrammar',
    component: 'DialogueUniversal',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'dialogueComp': {
    displayName: 'Comprehension Dialogue',
    routePath: 'dialogueComp',
    component: 'DialogueUniversal',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'vocabulary': {
    displayName: 'Vocabulary Practice',
    routePath: 'vocabulary',
    component: 'VocabularyFeature',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'translation': {
    displayName: 'Translation Matching',
    routePath: 'translation',
    component: 'TranslationMatching',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'grammar': {
    displayName: 'Grammar Module',
    routePath: 'grammar',
    component: 'GrammarFeature',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'cloze': {
    displayName: 'Cloze Exercise',
    routePath: 'cloze',
    component: 'ClozeExercise',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'shapePuzzle': {
    displayName: 'Shape Puzzle',
    routePath: 'shapePuzzle',
    component: 'ShapePuzzle',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'shapePuzzleNew': {
    displayName: 'Shape Puzzle New',
    routePath: 'shapePuzzleNew',
    component: 'ShapePuzzleNew',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'vocabularyLearn': {
    displayName: 'Vocabulary Learn',
    routePath: 'vocabularyLearn',
    component: 'VocabularyLearn',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z',
    actualExport: 'VocabMatchingAndTyping'
  },
  'grammarLearn': {
    displayName: 'Grammar Learn',
    routePath: 'grammarLearn',
    component: 'GrammarLearn',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z',
    actualExport: 'GrammarFeature'
  },
  'complete': {
    displayName: 'Chapter Complete',
    routePath: 'complete',
    component: 'ChapterCompletion',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2024-01-01T00:00:00.000Z'
  },
  'testVocabPractice': {
    displayName: 'Test Vocab Practice',
    routePath: 'testVocabPractice',
    component: 'TestVocabPractice',
    // filePath removed - using static imports,
    discovered: true,
    discoveredAt: '2025-01-02T00:00:00.000Z'
  },
  'teach': {
    displayName: 'Teach Module (Generic)',
    routePath: 'teach',
    component: 'TeachModule',
    discovered: true,
    discoveredAt: '2026-01-02T00:00:00.000Z'
  },
  'teachGrammar': {
    displayName: 'Teach Module (Grammar)',
    routePath: 'teachGrammar',
    component: 'TeachModule',
    discovered: true,
    discoveredAt: '2026-01-02T00:00:00.000Z'
  },
  'vocabTeach': {
    displayName: 'Vocab Teach Module',
    routePath: 'vocabTeach',
    component: 'VocabTeachModule',
    discovered: true,
    discoveredAt: '2026-01-06T00:00:00.000Z'
  },
  'advertTeach': {
    displayName: 'Advert Teach Module',
    routePath: 'advertTeach',
    component: 'AdvertTeachModule',
    discovered: true,
    discoveredAt: '2026-01-15T00:00:00.000Z'
  },
  'comicReader': {
    displayName: 'Comic Reader',
    routePath: 'comicReader',
    component: 'ComicReader',
    discovered: true,
    discoveredAt: '2026-01-25T11:20:00.000Z'
  },
  'teachModule': {
    displayName: 'Vocab Teach Module',
    routePath: 'teachModule',
    component: 'VocabTeachModule',
    discovered: true,
    discoveredAt: '2026-10-12T00:00:00.000Z'
  },
  'dialogueConclusion': {
    displayName: 'Conclusion Dialogue',
    routePath: 'dialogueConclusion',
    component: 'DialogueUniversal',
    discovered: true,
    discoveredAt: '2026-10-12T00:00:00.000Z'
  },
  'review': {
    displayName: 'AI Review Session',
    routePath: 'review',
    component: 'ReviewGenerator',
    discovered: true,
    discoveredAt: '2026-10-12T00:00:00.000Z'
  },
  'videoCutscene': {
    displayName: 'Video Cutscene',
    routePath: 'videoCutscene',
    component: 'VideoCutscenePlayer',
    discovered: true,
    discoveredAt: '2026-10-14T00:00:00.000Z'
  },
};

/** Silent accessor for the default module map (scanComponentsDirectory logs heavily) */
export const getDefaultModuleMap = () => AVAILABLE_COMPONENTS_REGISTRY;


/**
 * Browser-compatible component scanner that returns predefined components
 * @returns {Object} Module mapping configuration from registry
 */
export const scanComponentsDirectory = () => {
  console.group('🔍 Component Scanner: Loading available components from registry');
  console.log('📋 Using predefined component registry (browser-compatible)');

  try {
    const moduleMap = { ...AVAILABLE_COMPONENTS_REGISTRY };

    console.log('✅ Loaded components from registry:', Object.keys(moduleMap).length);
    console.log('📦 Available components:', Object.keys(moduleMap));

    console.groupEnd();
    return moduleMap;

  } catch (error) {
    console.error('❌ Error loading component registry:', error);
    console.groupEnd();
    return {};
  }
};

// Utility functions removed to resolve ESLint warnings (defined but never used)


/**
 * Merges discovered modules with existing module mapping
 * @param {Object} existingMapping - Existing module mapping
 * @param {Object} discoveredModules - Newly discovered modules
 * @returns {Object} Merged module mapping
 */
export const mergeModuleMappings = (existingMapping = {}, discoveredModules = {}) => {
  console.group('🔄 Module Mapping Merger');
  console.log('📋 Existing modules:', Object.keys(existingMapping).length);
  console.log('🔍 Discovered modules:', Object.keys(discoveredModules).length);

  const merged = { ...existingMapping };
  let newModules = 0;
  let updatedModules = 0;

  Object.entries(discoveredModules).forEach(([moduleId, config]) => {
    if (!merged[moduleId]) {
      merged[moduleId] = config;
      newModules++;
      console.log(`➕ Added new module: ${moduleId}`);
    } else {
      // Update existing module with discovery info
      merged[moduleId] = {
        ...merged[moduleId],
        ...config,
        lastDiscovered: config.discoveredAt
      };
      updatedModules++;
      console.log(`🔄 Updated module: ${moduleId}`);
    }
  });

  console.log('📊 Merge summary:', {
    total: Object.keys(merged).length,
    new: newModules,
    updated: updatedModules
  });

  console.groupEnd();
  return merged;
};

/**
 * Validates module mapping configuration
 * @param {Object} moduleMapping - Module mapping to validate
 * @returns {Object} Validation result
 */
export const validateModuleMapping = (moduleMapping) => {
  console.group('✅ Module Mapping Validator');

  const validation = {
    isValid: true,
    errors: [],
    warnings: [],
    stats: {
      total: Object.keys(moduleMapping).length,
      withDisplayName: 0,
      withRoutePath: 0,
      withComponent: 0,
      withFilePath: 0
    }
  };

  Object.entries(moduleMapping).forEach(([moduleId, config]) => {
    // Check required fields
    if (!config.displayName) {
      validation.errors.push(`Module ${moduleId} missing displayName`);
      validation.isValid = false;
    } else {
      validation.stats.withDisplayName++;
    }

    if (!config.routePath) {
      validation.errors.push(`Module ${moduleId} missing routePath`);
      validation.isValid = false;
    } else {
      validation.stats.withRoutePath++;
    }

    if (!config.component) {
      validation.errors.push(`Module ${moduleId} missing component`);
      validation.isValid = false;
    } else {
      validation.stats.withComponent++;
    }

    if (!config.filePath) {
      validation.warnings.push(`Module ${moduleId} missing filePath`);
    } else {
      validation.stats.withFilePath++;
    }
  });

  console.log('📊 Validation results:', validation);
  console.groupEnd();

  return validation;
};

/**
 * Adds a new component to the registry (for admin use)
 * @param {string} moduleId - Module ID
 * @param {Object} config - Component configuration
 * @returns {Object} Updated registry
 */
export const addComponentToRegistry = (moduleId, config) => {
  console.group('➕ Component Registry: Adding new component');
  console.log('Module ID:', moduleId);
  console.log('Config:', config);

  try {
    const newComponent = {
      displayName: config.displayName || moduleId,
      routePath: config.routePath || moduleId,
      component: config.component || `${moduleId}Feature`,
      // filePath removed - was causing Webpack empty media files
      discovered: true,
      discoveredAt: new Date().toISOString()
    };

    AVAILABLE_COMPONENTS_REGISTRY[moduleId] = newComponent;

    console.log('✅ Component added to registry:', moduleId);
    console.groupEnd();

    return { ...AVAILABLE_COMPONENTS_REGISTRY };
  } catch (error) {
    console.error('❌ Error adding component to registry:', error);
    console.groupEnd();
    return AVAILABLE_COMPONENTS_REGISTRY;
  }
};

/**
 * Gets the current component registry
 * @returns {Object} Current component registry
 */
export const getComponentRegistry = () => {
  return { ...AVAILABLE_COMPONENTS_REGISTRY };
};

const componentScanner = {
  scanComponentsDirectory,
  mergeModuleMappings,
  validateModuleMapping,
  addComponentToRegistry,
  getComponentRegistry
};

export default componentScanner;
